import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import {
  PATH_BENEFITS_INSURANCE,
  PATH_BENEFITS_INSURANCE_DETAILS
} from "../../paths";
import { RouteBenefitsInsurance } from "./RouteBenefitsInsurance";
import { BENEFITS_INSURANCE_TABS } from "./contsants";
import { RouteBenefitDetails } from "../RouteBenefitDetails";

export const RouteBenefitsInsuranceIndex: React.FC = () => {
  return (
    <Switch>
      <Route
        path={PATH_BENEFITS_INSURANCE_DETAILS}
        exact
        component={RouteBenefitDetails}
      />

      <Route
        path={[
          PATH_BENEFITS_INSURANCE,
          ...BENEFITS_INSURANCE_TABS.map(
            tabPath => `${PATH_BENEFITS_INSURANCE}/${tabPath}`
          )
        ]}
        component={RouteBenefitsInsurance}
      />

      <Redirect from="*" to={PATH_BENEFITS_INSURANCE} />
    </Switch>
  );
};
